/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import { Typography, Box, FormControl } from "@mui/material";
import React, { useState, useEffect } from "react";
import styles from "../devotee.module.scss";
import { useNavigate } from "react-router-dom";
import constants from "../../../config/constants.json";
import {
  CustomInputLabel,
  CustomMenuItem,
  CustomSearchFeild,
  CustomSelect,
} from "../../common/StyledComponents/StyledFields";
import Grid from "@mui/material/Grid";
import SearchIcon from "@mui/icons-material/Search";
import InputAdornment from "@mui/material/InputAdornment";
import {
  apiRequest,
  catchErrorMessageHandler,
} from "../../../infrastructure/backendService";
import Pagination from "../../common/pagination/pagination";
import { isEmpty, isNil, isNull, isUndefined } from "lodash";
import apiPath from "../../../config/apiPaths.json";
import toast from "react-hot-toast";
import ErrorPopup from "../../common/ErrorPopup";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const ScMember = (): JSX.Element => {
  const date = new Date();
  const currentYear = date.getFullYear();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [filteredScMemberDetails, setFilteredScMemberDetails] = useState<any[]>(
    []
  );
  const [SCmeetingListData, setSCmeetingListData] = useState<any[]>([]);
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [selectedYear, setSelectedYear] = useState<number | null>(null);
  const [yearsList, setYearsList] = useState<number[]>([]);


  useEffect(() => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.scMeetingYearDropDownApi,
      includeToken: true,
      params: {
        sortBy: "year",
        page: pageNumber - 1,
        size: 100,
        direction: "desc",
      },
    })
      .then((res) => {
        const years = res.data.content;
        setYearsList(res.data.content);
        const yearPresent = years.some((year:number) => year === currentYear);
        if (!yearPresent) {
          setSelectedYear(years[0])
        } else {
          setSelectedYear(currentYear)
        }
      })
      .catch((err) => {
        console.log(err);
        toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
          duration: constants.TOAST_POPUP_DURATION,
        });
      });
  }, []);

  /* filter for sc meeting by year api end*/

  useEffect(() => {
    if (selectedYear) {
      apiRequest({
        method: "GET",
        endpoint: apiPath.meetingOfMinutes,
        includeToken: true,
        params: {
          page: pageNumber - 1,
          size: 10,
          year :selectedYear
        },
      })
        .then((res) => {
          setSCmeetingListData(res.data.content);
          setTotalRecords(res.data.totalElements);
        })
        .catch((err) => {
          console.log(err);
          toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
            duration: constants.TOAST_POPUP_DURATION,
          });
        });
    }
  }, [pageNumber, selectedYear]);

  useEffect(() => {
    filterTableData();
  }, [searchQuery]);


  const filterTableData = () => {
    const lowerCaseQuery = searchQuery.toLowerCase();

    const filteredData = SCmeetingListData.filter((item: any) => {
      const meetingDate = item["meetingDate"].toLowerCase();
      const enteredDate = item["enteredDate"].toLowerCase();
      const documentName = item["documentName"].toLowerCase();
      return (
        meetingDate.includes(lowerCaseQuery) ||
        enteredDate.includes(lowerCaseQuery) ||
        documentName.includes(lowerCaseQuery)
      );
    });

    setFilteredScMemberDetails(filteredData);
  };

  const handleFileClick = (fileUrl: string) => {
    // Implement the action you want to take when a file is clicked
    if (
      !isNil(fileUrl) ||
      !isEmpty(fileUrl) ||
      !isNull(fileUrl) ||
      !isUndefined(fileUrl)
    ) {
      window.open(`${fileUrl}`, "_blank");
      // You can use window.open(fileUrl) to open the URL in a new tab/window
    }
  };

  const SCMetingMinutesTableData = () => {
    // const keysToShow = Object.keys(SCmeetingListData[0]).filter(
    //   (key) => key !== "fileUrl"
    // );
    // const keysToShow = Object.keys(filteredScMemberDetails[0] || {}).filter(
    //    (key) => key !== 'fileUrl',
    // );

    return (
      <>
      {SCmeetingListData.length> 0 ? <div className={styles.tableContainer}>
        <Grid
          sx={{ padding: "0 15px 0 20px" }}
          className={styles.cardContainer}
        >
          <table className={styles.table}>
            <thead>
              <tr className={styles.headerTableRow}>
                <th className={styles.tableHorizontal}>Meeting Date</th>
                <th className={styles.tableHorizontal}>Document Name</th>
                <th className={styles.tableHorizontal}>Uploaded Date</th>
              </tr>
            </thead>
            <tbody>
              {SCmeetingListData.map((item: any, index) => (
                <tr key={index} className={styles.tableRow}>
                  <td className={styles.tableDiagonal}>{item.meetingDate}</td>
                  <td
                    className={`${styles.tableDiagonal} ${styles.documentName}`}
                  >
                    <div
                      onClick={() => {
                        handleFileClick(item.fileUrl);
                      }}
                    >
                      {isNull(item.uniqueName)
                        ? item.documentName
                        : item.uniqueName}
                    </div>
                  </td>
                  <td className={styles.tableDiagonal}>{item.enteredDate}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Grid>
      </div> : <div style={{textAlign:"center"}}><p>No Data</p></div>}
      </>
    );
  };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(event.target.value);
  };

  const SearchBox = () => {
    return (
      <div className={styles.searchBox}>
        <CustomSearchFeild
          id="input-with-icon-textfield"
          placeholder="Search"
          value={searchQuery}
          onChange={handleSearchChange}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ color: "#F05802" }} />
              </InputAdornment>
            ),
          }}
        />
      </div>
    );
  };

  /* filter dropdown we need later */

  const handleYearsDropdown = (value: any) => {
    setSelectedYear(value);
  };

  const YearsDropDown = (): React.ReactElement => {
    return (
      <FormControl className={styles.dropdownStyle} sx={{ width: "100%" }}>
        <CustomSelect
          IconComponent={KeyboardArrowDownIcon}
          id="grouped-select"
          placeholder="Select Year"
          value={selectedYear}
          // renderValue={selectedYear !== null ? undefined : () => <span style={{ color: 'black' }}>All</span>}
          onChange={(e) => {
            handleYearsDropdown(e.target.value);
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                border: "1px solid #F05802",
                "& ul": {
                  paddingTop: 0,
                  paddingBottom: 0,
                  overflowY: "auto",
                  minHeight: "auto",
                  maxHeight: "300px",
                  "&::-webkit-scrollbar": {
                    width: "8px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#F3C539",
                    borderRadius: "6px",
                  },
                },
              },
            },
          }}
        >
          {yearsList.map((item: number, index: number) => (
            <CustomMenuItem key={index} value={item}>
              {item}
            </CustomMenuItem>
          ))}
        </CustomSelect>
      </FormControl>
    );
  };

  const headerComponent = () => {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          padding: "15px 20px",
          alignItems: "center",
        }}
      >
        <Typography className={styles.scheader}>SC Meeting Minutes</Typography>
        <Box>
        <CustomInputLabel>Select Year</CustomInputLabel>
        {YearsDropDown()}
        </Box>
        {/* {SearchBox()} */}
      </Box>
    );
  };

  const SCMeetingMinutesComponent = () => {
    return (
      <div className={styles.scContainer}>
        {headerComponent()}
        {SCMetingMinutesTableData()}
        {totalRecords > 10 ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "end",
              mr: "20px",
              py:"10px",
            }}
          >
            <Pagination
              items={totalRecords}
              itemsPerPage={10}
              setPageNumber={setPageNumber}
              pageNumber={pageNumber}
            />
          </Box>
        ) : (
          ""
        )}
      </div>
    );
  };

  const showScMember = (): React.ReactElement => {
    return (
      <Box className={styles.showScMembersContainer}>
        <Grid item xs={12}>
          {SCMeetingMinutesComponent()}
        </Grid>
      </Box>
    );
  };

  return (
    <Box className={styles.ScMemberLayout}>
      {showScMember()}
    </Box>
  );
};

export default ScMember;
